export default "__VITE_ASSET__46bd1fdd__"